const React = require('react');
const Avatar = require('./commonControls.jsx.js').userAvatar;
const Link = require('react-router-dom').Link;
const SharedConstants = require('../../../../shared/sharedConstants');
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton/IconButton";
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Tooltip from '@material-ui/core/Tooltip';
import ReactLinkify from "react-linkify";
import { UserAvatarV2 } from "./commonControls.jsx.js";
const moment = require('moment')
export class Comment extends React.Component{
   constructor(props) {
      super(props);
   }
   render() {
      let tooltipTitle = (title) => {
         return (
            <React.Fragment>
               <div style={{ fontSize: SharedConstants.TooltipValue.FontSize, lineHeight: SharedConstants.TooltipValue.LineHeight }}>
                  {title}
               </div>
            </React.Fragment>
         )
      };
      let bgColor = this.props.isSponsorComment ? '#D7F0FF' : '#FFFFFF'
      let commentDeletionPeriod = this.props.deletionTime ? this.props.deletionTime : 60;
      return(
         <div style={{borderLeft: `${this.props.showSideBorder===true ? 10 : 0}px solid lightGrey`,background:bgColor}}>
         <ListItem className='card-comment' >
         
            <ListItemAvatar>
               <UserAvatarV2 size='small' userData={this.props.user} />
            </ListItemAvatar>
            <div>
               <Link to={'/users/profile?idUser=' + this.props.user.id}>
                  {`${this.props.isSponsorComment === true?'': ''} ${this.props.user.firstName} ${this.props.user.lastName}`}
               </Link>
               <div style={{display : 'inline-block',marginLeft:'1em',color: '#869799'}}>
               {this.props.commentTime && `${moment(this.props.commentTime).calendar()}`}
               </div>
               <div className='card-comment-body'>
                  <ReactLinkify>
                     {this.props.text}
                  </ReactLinkify>
               </div>
            </div>
            {
               this.props.showDelete && (((this.props.minutesSinceCreation < commentDeletionPeriod && this.props.user.id === parseInt(window.globals.idUser)) || (window.globals.isSponsor)) ?
               <Tooltip title={(window.globals.isSponsor)? tooltipTitle('As a sponsor, you can delete this comment'): tooltipTitle(`Comments can be deleted up to ${commentDeletionPeriod} minutes after they are posted.`) }>
                  <ListItemSecondaryAction>
                     <IconButton aria-label="Delete" onClick={() => this.props.deleteCommentFunction()}>
                        <FontAwesomeIcon icon={['fas', "times"]}/>
                     </IconButton>
                  </ListItemSecondaryAction>
               </Tooltip>:
              (this.props.openReportModal && <Tooltip title={tooltipTitle('Report this comment')}>
                  <ListItemSecondaryAction>
                     <IconButton aria-label="Report" onClick={() => this.props.openReportModal()}>
                        <FontAwesomeIcon icon={['far', "flag"]}/>
                     </IconButton>
                  </ListItemSecondaryAction>
               </Tooltip>))
            }
         </ListItem>
         </div>
      );
   }
}